import { render, staticRenderFns } from "./DeliveryBillListToDoByBack.vue?vue&type=template&id=4c44e270&scoped=true&"
import script from "./DeliveryBillListToDoByBack.vue?vue&type=script&lang=js&"
export * from "./DeliveryBillListToDoByBack.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryBillListToDoByBack.vue?vue&type=style&index=0&id=4c44e270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44e270",
  null
  
)

export default component.exports